import React from "react";
import CustomTabs from "components/Shared/CustomTabs";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useIncidentReportDetailContext } from "contexts/IncidentReportDetailContext";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import NoteTab from "../../Note/Notetab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";

const IncidentReportDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "notes";

  const { incidentReportDetail } = useIncidentReportDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "IncidentReport",
      sourceRef: incidentReportDetail?._id,
    },
    { skip: !incidentReportDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "IncidentReport", sourceRef: incidentReportDetail?._id },
    { skip: !incidentReportDetail?._id }
  );

  const tabs = [
    {
      label: "Notes",
      value: "notes",
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {incidentReportDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="notes">
            <NoteTab
              source="IncidentReport"
              sourceRef={incidentReportDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="IncidentReport"
              sourceRef={incidentReportDetail._id}
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default IncidentReportDetailTab;
